import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSurveyLinkedQnsAction = createAsyncThunk(
    'survey-linked-qns',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/survey-linked-qns?survey_id=${data}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSurveyLinkedQnsSlice = createSlice({
    name: 'survey-linked-qns',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSurveyLinkedQnsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSurveyLinkedQnsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSurveyLinkedQnsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSurveyLinkedQnsReducer = getSurveyLinkedQnsSlice.reducer    